export const GET_NEXT_MATERIAL_EVENT_NAME = 'get-next-material-event-name';
export const CHANGE_MATERIAL_URL_EVENT_NAME = 'change-material-url-event-name';
export const CHANGE_CONTENT = 'change-content';
export const GET_PARTNER_MATERIAL_EVENT = 'get-partner-material-event';

export const addEventListener = (name)=>{
    return new Promise((resolve, reject) => {
        document.addEventListener(name, function(event) {
            resolve(event);
        });
    });
};

export const dispatchEvent = (name, data) =>{
    document.dispatchEvent(new CustomEvent(name, data));
};
